import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { User, Workspace } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0150. ワークスペースユーザ一覧
 * [GET] /workspaces/:identifier/users
 */
type Props = {
  identifier: string;
  include_invalidity?: boolean;
  except_team_id?: number;
  no_cache?: boolean;
};
const workspaceUsers = (props: Props): Promise<User[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/users`, { params: props });
};

export const useWorkspaceUsers = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'users'],
    queryFn: () => workspaceUsers(props),
    staleTime: props.no_cache ? 10 : Number(process.env.REACT_APP_API_STALE_TIME),
  });
};

export const useWorkspaceUsersInvalidate = (identifier: string) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: ['workspaces', identifier, 'users'] });
  };

  return { invalidate };
};
